import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'datefrench2'
})



export class DateFPipe2 implements PipeTransform {
  transform(start_date:any): any {
    let days = ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'];
    let months = ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet','Aout','Septembre','Octobre','Novembre','Decembre'];
    let d = new Date(start_date.replace(/ /g,"T"));
    let dayname = days[d.getUTCDay()];
    let day= d.getUTCDate();
    let hours = d.getHours();

    let month = months[d.getMonth()];

    return dayname +' '+day+' '+month;
  }
}
